import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function PaystackTopUp({ orgId, credits }) {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/billing/paystack/config").then(r => setCfg(r.data)).catch(() => setCfg({ enabled: false }));
  }, []);
  if (!cfg) return null;
  if (!cfg.enabled) {
    return (
      <p className="k-muted" data-testid="paystack-disabled" style={{ fontSize: 12 }}>
        Paystack isn’t configured yet — add PAYSTACK_SECRET_KEY to enable it.
      </p>
    );
  }
  const pay = async () => {
    setBusy(true);
    try {
      // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
      const callback_url = `${window.location.origin}/payment/paystack/callback`;
      const { data } = await api.post(`/billing/paystack/orgs/${orgId}/initialize`, { credits, callback_url });
      window.location.href = data.authorization_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <div data-testid="paystack-topup">
      <div className="k-muted" style={{ fontSize: 11, marginBottom: 6 }}>or pay with Paystack</div>
      <button className="k-btn k-btn-ghost" data-testid="paystack-pay" disabled={busy}
        style={{ width: "100%" }} onClick={pay}>
        {busy ? "Redirecting…" : `Pay with Paystack · ${credits} credits`}
      </button>
    </div>
  );
}
